import axios from "axios";
import { myLocalStorage } from "../components/StorageHelper";

const binaryApi = axios.create({
    responseType: "arraybuffer",
    transformResponse: (r) => r
});

binaryApi.interceptors.request.use((req) => {
    const token = myLocalStorage.getItem("access_token");
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
});

export default binaryApi;
